import React from 'react';
import PropTypes from 'prop-types';

export default function CalendarIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <g data-name='Grupo 151523'>
        <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148000' />
        <path
          fill={fill}
          d='M14.444 9.1H5.556v1.8h8.889Zm1.778-6.3h-.889V1h-1.777v1.8H6.444V1H4.667v1.8h-.889a1.781 1.781 0 0 0-1.769 1.8L2 17.2A1.789 1.789 0 0 0 3.778 19h12.444A1.794 1.794 0 0 0 18 17.2V4.6a1.794 1.794 0 0 0-1.778-1.8Zm0 14.4H3.778V7.3h12.444Zm-4.444-4.5H5.556v1.8h6.222Z'
        />
      </g>
    </svg>
  );
}

CalendarIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

CalendarIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
